import PropTypes from 'prop-types';

export const ProductDetailDefaultProps = {
  brand: {},
  className: '',
  code: '',
  discountPrice: 0,
  image: {},
  invoiceUnit: '',
  manufacturerSku: '',
  name: '',
  publicPrice: 0,
  range: '',
  saleUnit: '',
  salesPackaging: 0,
  taxRate: 0,
  weeeAmount: 0,
};

export const ProductDetailPropTypes = {
  brand: PropTypes.shape({ name: PropTypes.string }),
  className: PropTypes.string,
  code: PropTypes.string,
  discountPrice: PropTypes.number,
  image: PropTypes.shape({ alt: PropTypes.string, url: PropTypes.string }),
  invoiceUnit: PropTypes.string,
  manufacturerSku: PropTypes.string,
  name: PropTypes.string,
  publicPrice: PropTypes.number,
  range: PropTypes.string,
  saleUnit: PropTypes.string,
  salesPackaging: PropTypes.number,
  taxRate: PropTypes.number,
  weeeAmount: PropTypes.number,
};
